import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import flagDe from '../../flags/de.svg';
import flagEs from '../../flags/es.svg';
import flagFr from '../../flags/fr.svg';
import flagGb from '../../flags/gb.svg';
import flagIt from '../../flags/it.svg';
import StyledBox from './styles';

export function LanguageFlag(props: { language: string }) {
  const { language } = props;
  const { t } = useTranslation('common');
  switch (language) {
    case 'fr':
      return (<img src={flagFr} alt={t(`languages.flag.${language}`)} />);
    case 'en':
      return (<img src={flagGb} alt={t(`languages.flag.${language}`)} />);
    case 'de':
      return (<img src={flagDe} alt={t(`languages.flag.${language}`)} />);
    case 'es':
      return (<img src={flagEs} alt={t(`languages.flag.${language}`)} />);
    case 'it':
      return (<img src={flagIt} alt={t(`languages.flag.${language}`)} />);
    default:
      return (<Typography>{language}</Typography>);
  }
}

export default function LanguageIndicator(props: { language: string }) {
  const { language } = props;
  const { t } = useTranslation('common');
  return (
    <StyledBox>
      <LanguageFlag language={language} />
      <Typography>{t(`languages.${language}`)}</Typography>
    </StyledBox>
  );
}
